import { safeLocalStorageGet, safeLocalStorageSet } from './safe-storage.js';

export type EditorTheme = 'system' | 'light' | 'dark';

export function getEditorTheme(): EditorTheme {
  const value = document.documentElement.dataset.editorTheme;
  return value === 'light' || value === 'dark' ? value : 'system';
}

function applyEditorTheme(value: string | null) {
  const root = document.documentElement;
  const requested = root.dataset.embedTheme;
  const selected = requested === 'light' || requested === 'dark' || requested === 'system' ? requested : value;
  const preference = selected === 'light' || selected === 'dark' ? selected : 'system';
  root.dataset.editorTheme = preference;
  root.dataset.theme = preference === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : preference;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content',
    root.dataset.theme === 'dark' ? '#1e293b' : '#ffffff');
  document.querySelectorAll('[data-editor-theme-select]').forEach(select => {
    if (select instanceof HTMLSelectElement) select.value = preference;
  });
  window.dispatchEvent(new Event('editor-theme-change'));
}

export function setEditorTheme(value: EditorTheme) {
  if (!document.documentElement.hasAttribute('data-embed-theme')) safeLocalStorageSet('theme', value);
  applyEditorTheme(value);
}

export function initEditorTheme() {
  applyEditorTheme(safeLocalStorageGet('theme'));
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-editor-theme-select')) return;
    const value = select.value;
    if (value === 'system' || value === 'light' || value === 'dark') setEditorTheme(value);
  });
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    applyEditorTheme(getEditorTheme());
  });
  window.addEventListener('storage', event => {
    if (event.storageArea === window.localStorage && (event.key === 'theme' || event.key === null)) {
      applyEditorTheme(event.newValue);
    }
  });
}
